import { render, staticRenderFns } from "./SingleTaskCard.vue?vue&type=template&id=0eb73930&"
import script from "./SingleTaskCard.vue?vue&type=script&lang=js&"
export * from "./SingleTaskCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SingleTaskCard.vue"
export default component.exports